import http from "services/http";

export interface CreateVehiclePayload {
  name: string;
  type: string;
  availability: boolean;
  seats: number;
  color: string;
  front_image: File;
}

export const createVehicle = async (payload: CreateVehiclePayload) => {
  const formData = new FormData();
  formData.append("name", payload.name);
  formData.append("type", payload.type);
  formData.append("availability", String(payload.availability));
  formData.append("seats", String(payload.seats));
  formData.append("color", payload.color);
  formData.append("front_image", payload.front_image);

  const response = await http.post("admin/createairportcar", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const getVehicles = async (): Promise<any> => {
  const response = await http.get("ride/getallcars");
  return response.data;
};

export const createVehiclePrice = async (data: {
  car_id: string;
  state: string;
  price: number;
  type: "area" | "distance";
  area?: string;
  minduration?: number;
  maxduration?: number;
}) => {
  const response = await http.post("admin/createairportcarprice", data);
  return response.data;
};

export const getStates = async () => {
  const response = await http.get("ride/getallstate");
  return response.data;
};

export const getAreas = async (stateId: string) => {
  const response = await http.get(`ride/getarea/${stateId}`);
  return response.data;
};

export const createState = async (data: { name: string; airport: string }) => {
  const response = await http.post("admin/createairportstate", data);
  return response.data;
};

export const createArea = async (data: { name: string; state: string }) => {
  const response = await http.post("admin/createstatearea", data);
  return response.data;
};

export const getRideDashboard = async (params: {
  page: number;
  limit: number;
}) => {
  const response = await http.get(`admin/dashboard/ride/manage`, { params });
  return response.data;
};

interface CreateAddonPayload {
  name: string;
  price: number;
  description: string;
  is_default: boolean | string;
}

export const createAddon = async (payload: CreateAddonPayload) => {
  const response = await http.post("admin/createaddon", payload);
  return response.data;
};

export const editAddon = async (id: string, payload: CreateAddonPayload) => {
  const response = await http.put(`admin/editaddon/${id}`, payload);
  return response.data;
};

export const deleteAddon = async (id: string) => {
  const response = await http.delete(`admin/deleteaddon/${id}`);
  return response.data;
};

export const getAddonList = async () => {
  const response = await http.get("admin/addonlist");
  return response.data;
};
